import React, { FC, ReactElement, useMemo, useRef, useEffect, useState } from 'react';
import videojs from 'video.js';
import { Result } from 'antd';
import { Download } from 'components'
import FileViewer from 'react-file-viewer';
import styles from './index.less';
import videozhCN from 'video.js/dist/lang/zh-CN.json';
import 'video.js/dist/video-js.css'

interface IProps {
  fileType: string,
  filePath: string,
  shortCode: string,
  resId?: number
  coverImg?: string
}

const VIEW_TYPE = {
  video: 2,
  other: 99
}


const CustomFileViewer: FC<IProps> = (props:IProps): ReactElement => {

  const {fileType, filePath, coverImg, shortCode, resId} = props
  const ft = useMemo(()=>{
    if(fileType === 'mp4'){
      return VIEW_TYPE.video
    }
    return VIEW_TYPE.other
  }, [fileType])
  const videoNode = useRef<HTMLVideoElement>(null)
  const [player, setPlayer] = useState<any>()

  // 视频播放参数
  const videoJsOptions = useMemo(()=>{
    return {
      language: 'zh-CN',
      //autoplay: true,
      controls: true,
      preload: 'auto',
      playbackRates: [0.5, 1, 1.5, 2],
      errorDisplay: true,
      controlBar: {
        // 竖直的音量控制
        volumePanel: {
          inline: false
        },
        subsCapsButton: false
      },
      poster: coverImg,
      sources: [{
        src: filePath,
        type: 'video/mp4'
      }]
    }
  }, [filePath, coverImg])

  useEffect(()=>{
    if(ft === VIEW_TYPE.video && filePath){
      videojs.addLanguage('zh-CN', videozhCN);
      const p = videojs(videoNode.current, videoJsOptions, function onPlayerReady() {
        //p.play()
        //p.src('http://192.168.197.131:2000/file/2021/06/01/9708dbde-a441-4303-9a42-3c6fec9cebce.mp4')
        console.log('onPlayerReady', filePath, coverImg)
        p.src(filePath)
        p.poster(coverImg)
      })
      setPlayer(p)
    }
    return ()=>{
      if(player){
        player.dispose()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ft, videoJsOptions, videoNode])

  const CustomErrorComponent = ()=>{
    return <Result
    status="warning"
    title="文件暂不支持预览"/>
  }

  const onError = (args:any)=>{
    console.log(args)
  }

  return (
    <div className={styles.viewer}>
      {
        ft === VIEW_TYPE.video && 
        <div className={styles.video} data-vjs-player >
          <video ref={videoNode} preload="true" className={['video-js', 'vjs-16-9', 'vjs-big-play-centered', styles.videoContent].join(' ')} >
            <track kind="captions" />
            <p className="vjs-no-js">您的浏览器不支持HTML5，请升级浏览器。</p>
          </video> 
        </div>
      }
      {
        ft === VIEW_TYPE.other &&
        <FileViewer 
          shortCode={shortCode}
          resId={resId}
          fileType={fileType}
          filePath={filePath}
          errorComponent={CustomErrorComponent}
          onError={onError}
          unsupportedComponent={UnsupportedComponent}/>
      }
    </div>
  )
}

const UnsupportedComponent: FC<IProps> = (props:IProps)=>{
  const { fileType, shortCode, resId } = props
  return (
    <div style={{display:'flex',alignItems:'center', justifyContent:'center'}}>
      <b>{`.${fileType}`}</b>文件暂不支持在线预览！请<Download shortCode={shortCode} resId={resId}><a type="link">下载</a></Download>.
    </div>
  )
}

export default CustomFileViewer